export function logInDev(message: string) {
    const devEnv = document.getElementById("devEnv");

    if (devEnv && devEnv.hasAttribute("ticked") && devEnv.getAttribute("ticked") === "true") {
        console.log(message);
    }
}